module.exports = require('./helpers/bundle-url').getBundleURL('hROql') + "logo-dark.eefe0b7f.svg";